import { render } from "./NewsItem.vue?vue&type=template&id=6e5aa37d&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=ts"
export * from "./NewsItem.vue?vue&type=script&lang=ts"

import "./NewsItem.vue?vue&type=style&index=0&id=6e5aa37d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e5aa37d"

export default script